module.exports = __webpack_public_path__ + "img/gamePrizeTitleImg.f96f55bd.png";